module.exports = __webpack_public_path__ + "assets/img/frame-top-left.c90959a4.png";